class CartDrawerUpsells extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.onClick.bind(this));
  }

  get cartDrawer() {
    return document.querySelector('cart-drawer');
  }

  get sections() {
    const cartDrawer = this.cartDrawer;
    if (!cartDrawer) return [];
    return cartDrawer.getSectionsToRender().map((section) => section.id);
  }

  async onClick(event) {
    const button = event.target.closest('[data-cart-upsell-add]');
    if (!button || button.disabled) return;

    event.preventDefault();
    try {
      await this.addVariant(button.dataset.variantId, button);
    } catch (error) {
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
      console.error(error);
    }
  }

  async addVariant(variantId, button = null) {
    if (!variantId) return;

    if (button) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
    }

    const body = JSON.stringify({
      id: variantId,
      quantity: 1,
      sections: this.sections,
      sections_url: window.location.pathname,
    });

    const response = await fetch(routes.cart_add_url, { ...fetchConfig(), body });
    const parsedState = await response.json();

    if (parsedState.status) {
      throw new Error(parsedState.description || parsedState.message || 'Unable to add product to cart.');
    }

    if (button) {
      const label = button.querySelector('span');
      if (label) label.textContent = 'Added to cart';
      button.classList.add('is-added');
    }

    this.renderCart(parsedState);
  }

  renderCart(parsedState) {
    const cartDrawer = this.cartDrawer;
    if (!cartDrawer || !parsedState.sections) return;
    cartDrawer.renderContents(parsedState);
  }
}

if (!customElements.get('cart-drawer-upsells')) {
  customElements.define('cart-drawer-upsells', CartDrawerUpsells);
}

window.GPOConfigs = window.GPOConfigs || {};
window.GPOConfigs.stayOnPdp = true;

function renderCartDrawerSectionsBeforeOpen(cartDrawer, renderedSections) {
  const nextCartDrawer = renderedSections['cart-drawer']
    ? new DOMParser().parseFromString(renderedSections['cart-drawer'], 'text/html').querySelector('cart-drawer')
    : null;
  const isEmpty = nextCartDrawer ? nextCartDrawer.classList.contains('is-empty') : false;

  cartDrawer.getSectionsToRender().forEach((section) => {
    if (!renderedSections[section.id]) return;

    const sectionElement = section.selector
      ? document.querySelector(section.selector)
      : document.getElementById(section.id);

    if (!sectionElement) return;
    sectionElement.innerHTML = cartDrawer.getSectionInnerHTML(renderedSections[section.id], section.selector);
  });

  cartDrawer.classList.toggle('is-empty', isEmpty);
  const drawerInner = cartDrawer.querySelector('.drawer__inner');
  if (drawerInner) drawerInner.classList.toggle('is-empty', isEmpty);

  const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
  if (overlay) overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));

  cartDrawer.open();
}

document.addEventListener('gpoAddedToCart', async () => {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  const sections = cartDrawer.getSectionsToRender().map((section) => section.id);
  if (!sections.length) {
    cartDrawer.open();
    return;
  }

  try {
    const url = `${routes.cart_url}?sections=${sections.join(',')}&sections_url=${encodeURIComponent(
      window.location.pathname
    )}`;
    const response = await fetch(url);
    const renderedSections = await response.json();

    renderCartDrawerSectionsBeforeOpen(cartDrawer, renderedSections);
  } catch (error) {
    console.error(error);
    cartDrawer.open();
  }
});
